// extracted by mini-css-extract-plugin
export default {"container":"topComparablePlayers_container__X-tkP","lastUpdatedDate":"topComparablePlayers_lastUpdatedDate__EjKKR","tableContainer":"topComparablePlayers_tableContainer__TZF3a"};